var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.99999C3 9.05991e-06 13 0 13 7.99996",
    stroke: "#9E9FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9823 8.5C12.9823 8.21409 13.2141 7.98231 13.5 7.98231C13.7859 7.98231 14.0177 8.21409 14.0177 8.5V9.5C14.0177 9.78591 13.7859 10.0177 13.5 10.0177C13.2141 10.0177 12.9823 9.78591 12.9823 9.5V8.5Z",
    stroke: "#9E9FA1",
    strokeWidth: 1.96461
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98231 8.5C1.98231 8.21409 2.21409 7.98231 2.5 7.98231C2.78591 7.98231 3.01769 8.21409 3.01769 8.5V9.5C3.01769 9.78591 2.78591 10.0177 2.5 10.0177C2.21409 10.0177 1.98231 9.78591 1.98231 9.5V8.5Z",
    stroke: "#9E9FA1",
    strokeWidth: 1.96461
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 13.4286 13.0366 14 10.5 14",
    stroke: "#9E9FA1",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H11",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.3c6793de0c75a8a04757af2a462f1f10.svg";
export { ForwardRef as ReactComponent };